import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    grayText: {
      color: theme.gray800,
      display: "block",
      fontSize: 18,
      margin: theme.spacing(12, 0, 8),
    },
    fullWidth: { maxWidth: "100%", width: "100%" },
    itemHeader: {
      fontSize: 18,
      marginBottom: theme.spacing(6),
    },
    clearicon: { marginLeft: "auto", marginBottom: theme.spacing(12) },
    productRow: {
      alignItems: "center",
      display: "flex",
      flexWrap: "wrap",
      maxWidth: "100%",
      "& + &": {
        borderTop: `1px solid ${theme.gray50}`,
        marginTop: theme.spacing(12),
        paddingTop: theme.spacing(6),
      },
    },
    error: {
      color: theme.red500,
      display: "block",
      fontSize: 14,
      marginBottom: theme.spacing(8),
      marginTop: theme.spacing(5),
      "& + &": { marginTop: 0 },
    },
    form: {
      marginTop: theme.spacing(12),
    },
  }),
);
